import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ModalContextType {
  showCreateRoomModal: boolean;
  setShowCreateRoomModal: (show: boolean) => void;
  createRoomModalProps: {
    projectId?: string;
    siteId?: string;
  };
  setCreateRoomModalProps: (props: { projectId?: string; siteId?: string }) => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

interface ModalProviderProps {
  children: ReactNode;
}

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const [showCreateRoomModal, setShowCreateRoomModal] = useState(false);
  const [createRoomModalProps, setCreateRoomModalProps] = useState<{
    projectId?: string;
    siteId?: string;
  }>({});

  return (
    <ModalContext.Provider
      value={{
        showCreateRoomModal,
        setShowCreateRoomModal,
        createRoomModalProps,
        setCreateRoomModalProps,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
}; 